// removed by extract-text-webpack-plugin
module.exports = {"dark":"#00171F","blue":"#00A8E8","white":"#FFFFFF","green":"#99C24D","btn":"src-components-InputButton----InputButton-module---btn---38B_r","orange":"src-components-InputButton----InputButton-module---orange---1tX-g src-components-InputButton----InputButton-module---btn---38B_r","normal":"src-components-InputButton----InputButton-module---normal---3TkdC src-components-InputButton----InputButton-module---btn---38B_r","large":"src-components-InputButton----InputButton-module---large---3ji-u src-components-InputButton----InputButton-module---btn---38B_r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputButton/InputButton.module.css
// module id = 206
// module chunks = 70144966829960 75563080901475